import { Component, OnInit } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnInit {
  loginForm: UntypedFormGroup;

  constructor(private readonly authService: AuthService, private readonly router: Router) {
    this.loginForm = new UntypedFormGroup({
      email: new UntypedFormControl(),
      password: new UntypedFormControl(),
    });
  }

  ngOnInit(): void {
  }

  login(): void {
    this.authService.login(this.loginForm.value.email, this.loginForm.value.password)
      .then(() => {
        this.router.navigate(['lists']);
      });
  }
}
